export const BaccaratIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_24579_45200)">
      <path
        d="M10.4309 11.4403C10.1965 11.1841 9.78956 11.1863 9.5587 11.4487L6.22417 15.2378C6.02944 15.4591 6.02944 15.7906 6.22417 16.0119L9.5587 19.801C9.78886 20.0626 10.1955 20.0667 10.4309 19.8094L13.8972 16.0203C14.102 15.7965 14.102 15.4532 13.8972 15.2294L10.4309 11.4403Z"
        fill="white"
      />
      <path
        d="M8.24219 0C6.88457 0 5.89844 1.13312 5.89844 2.51242C5.89844 4.26145 7.51422 5.34168 9.61414 7.17922C9.83512 7.37254 10.1649 7.3725 10.3859 7.17922C12.4859 5.3416 14.1016 4.26105 14.1016 2.51246C14.1016 1.13305 13.1154 0 11.7578 0C11.0649 0 10.4602 0.304492 10 0.882812C9.53977 0.304492 8.93512 0 8.24219 0Z"
        fill="white"
      />
      <path
        d="M5.85938 11.875C7.15172 11.875 8.20312 10.8236 8.20312 9.53125C8.20312 8.44066 7.45441 7.52168 6.44402 7.26133C6.49031 5.95949 5.43598 4.84375 4.10156 4.84375C2.76719 4.84375 1.71281 5.95949 1.7591 7.26133C0.748711 7.52168 0 8.44066 0 9.53125C0 10.8236 1.05141 11.875 2.34375 11.875C2.77047 11.875 3.17062 11.7599 3.51562 11.5598V13.0469H2.92969C2.60609 13.0469 2.34375 13.3092 2.34375 13.6328C2.34375 13.9564 2.60609 14.2188 2.92969 14.2188H5.27344C5.59703 14.2188 5.85938 13.9564 5.85938 13.6328C5.85938 13.3092 5.59703 13.0469 5.27344 13.0469H4.6875V11.5598C5.0325 11.7599 5.43266 11.875 5.85938 11.875Z"
        fill="white"
      />
      <path
        d="M16.2843 4.84227C16.0634 4.64898 15.7335 4.64898 15.5126 4.84227C13.4126 6.67988 11.7969 7.76043 11.7969 9.50906C11.7969 10.8885 12.7831 12.0215 14.1406 12.0215C14.5696 12.0215 14.9645 11.9045 15.3125 11.6784V13.0469H14.7266C14.403 13.0469 14.1406 13.3092 14.1406 13.6328C14.1406 13.9564 14.403 14.2188 14.7266 14.2188H17.0703C17.3939 14.2188 17.6562 13.9564 17.6562 13.6328C17.6562 13.3092 17.3939 13.0469 17.0703 13.0469H16.4844V11.6784C16.8323 11.9045 17.2273 12.0215 17.6562 12.0215C19.0139 12.0215 20 10.8884 20 9.50906C20 7.76004 18.3842 6.6798 16.2843 4.84227Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_24579_45200">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
